import { render, staticRenderFns } from "./cadpaises.vue?vue&type=template&id=20dc8b91&"
import script from "./cadpaises.vue?vue&type=script&lang=js&"
export * from "./cadpaises.vue?vue&type=script&lang=js&"
import style0 from "./cadpaises.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports